import { useCallback } from 'react';
import { Clipboard, Linking } from 'react-native';
import { useToast } from '@shared/components/toast';
import { MBActionSheet } from '@shared/util/actionSheet';
import { i18n } from '@shared/util/i18n';

export function useShowUrlActionSheet({ url }: { url: string }) {
  const toast = useToast();
  return useCallback(() => {
    MBActionSheet.show({
      message: url,
      options: [
        {
          title: i18n('workflowTemplate.component.url.actionButtonsSheet.openInBrowser'),
          onPress: () => {
            Linking.openURL(url);
          },
        },
        {
          title: i18n('workflowTemplate.component.url.actionButtonsSheet.copyLink'),
          onPress: () => {
            Clipboard.setString(url);
            toast.show({
              icon: 'check-filled',
              message: i18n('workflowTemplate.component.url.actionButtonsSheet.copiedToClipboard'),
            });
          },
        },
      ],
    });
  }, [url, toast]);
}
